export { default } from './ProfileEditPasswordPage';
export { default as template } from './profile-edit-password-page.tpl';
